import { runBudgetImport } from "./framework/runBudgetImport";
import { BudgetImportConfig } from "./framework/types";
import { scbiConfig } from "./scbi";
import { wrightRyanConfig } from "./wright-ryan";
import { robinsMortonConfig } from "./robinsmorton";
import { journeyConfig } from "./journey";
import { fiteConfig } from "./fitebuilding";
import { kccoConfig } from "./kcco";
import { fortisConfig } from "./fortis";

/** An export builder returns its file's lines plus the extension to save them under. */
export type ExportBuilder = () => Promise<[string[], string]>;

/** Tenants with a budget import. Adding one here is what makes it reachable. */
export type BudgetImportTenant =
  | "scbi"
  | "wright-ryan"
  | "robinsmorton"
  | "journey"
  | "fitebuilding"
  | "kcco"
  | "fortis";

/**
 * A tenant is a config, not a function: the shared pipeline in `framework/` does the fetching and
 * rendering, and the config supplies only what varies. Onboarding a tenant already on a format
 * family is an entry here plus its config module.
 *
 * Keyed and `satisfies`-checked rather than a switch, so a missing tenant is a compile error. The
 * previous switch fell through to an empty result, which the UI reported as nothing happening.
 */
const BUDGET_IMPORTS = {
  scbi: scbiConfig,
  "wright-ryan": wrightRyanConfig,
  robinsmorton: robinsMortonConfig,
  journey: journeyConfig,
  fitebuilding: fiteConfig,
  kcco: kccoConfig,
  fortis: fortisConfig,
} satisfies Record<BudgetImportTenant, BudgetImportConfig>;

export const hasBudgetImport = (tenant: string | null): tenant is BudgetImportTenant =>
  tenant !== null && tenant in BUDGET_IMPORTS;

export const budgetImportFor =
  (tenant: BudgetImportTenant): ExportBuilder =>
  () =>
    runBudgetImport(BUDGET_IMPORTS[tenant]);
